/**
 * 标签池公共逻辑：删除标签 + 提交前的上下文校验。
 *
 * 通用池 / 公司池 / 业务池的删除流程完全一致，差异通过覆盖以下方法约定：
 *  1. validateBatchContext()：返回提示文案表示校验不通过，返回 '' 表示通过；
 *  2. getOperationContext()：返回删除接口所需的 { companyId, groupId }；
 *  3. onTagDeleted()：删除成功后的列表刷新逻辑。
 */
export default {
  methods: {
    // 上下文校验规则：默认要求选中归属公司与业务子类型（业务池口径）
    validateBatchContext() {
      if (this.selectedCompany == null) return '请先选择归属公司';
      if (this.selectedBizType == null) return '请先选择业务子类型';
      return '';
    },
    // 提交前的上下文校验：不通过时给出提示并返回 false
    checkBatchContext() {
      const message = this.validateBatchContext();
      if (message) {
        this.$message.warning(message);
        return false;
      }
      return true;
    },
    // 标签操作接口的归属公司 / 策略组入参，默认取当前选中项
    getOperationContext() {
      return {
        companyId: this.selectedCompany == null ? 0 : this.selectedCompany,
        groupId: this.selectedBizType == null ? 0 : this.selectedBizType
      };
    },
    // 删除成功后的刷新逻辑，由各标签池按需覆盖
    onTagDeleted() {},
    // 删除标签：确认后调用后端删除接口，成功后刷新列表
    deleteTag(tag) {
      if (!this.checkBatchContext()) return false;
      this.$confirm(`确定删除标签 "${tag && tag.name}" 吗？`, '提示', { type: 'warning' })
        .then(() => this.submitDeleteTag(tag))
        .catch(() => {});
      return true;
    },
    // 实际发起删除请求；取消确认不会进入这里，故接口失败统一提示「删除失败」
    submitDeleteTag(tag) {
      const { companyId, groupId } = this.getOperationContext();
      return this.$ajax({
        url: '/label/deleteLabel',
        method: 'POST',
        data: {
          // 标签关系 id（relation_id）
          id: tag.id,
          // 归属公司
          companyId,
          // 策略组（业务子类型）
          groupId,
          // 操作类型：删除
          operationType: 'delete'
        }
      })
        .then(() => {
          this.onTagDeleted();
          this.$message.success('已删除');
        })
        .catch(() => {
          this.$message.error('删除失败');
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/page/main/tagpools/tag-pool-mixin.js